<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="goodsId">
        <span slot="label"><a-tooltip>{{ $t('选择商品') }}<template slot="title">{{ $t('选择商品') }}</template></a-tooltip> </span>
        <a-button :disabled="formType===2" plain type="primary" @click="openGoodsSelect">{{ $t('选择商品') }}</a-button>
      </a-form-model-item>
      <a-form-model-item prop="goodsName">
        <span slot="label"><a-tooltip>{{ $t('商品名称') }}<template slot="title">{{ $t('商品名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.goodsName" :maxLength="100" :disabled="true" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="nickName">
        <span slot="label"><a-tooltip>{{ $t('昵称') }}<template slot="title">{{ $t('昵称') }}</template></a-tooltip> </span>
        <a-input v-model="form.nickName" :maxLength="128" :placeholder="$t('请输入')+$t('昵称')"  allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="content">
        <span slot="label"><a-tooltip>{{ $t('内容') }}<template slot="title">{{ $t('内容') }}</template></a-tooltip> </span>
        <a-input v-model="form.content" :maxLength="100" :placeholder="$t('请输入')+$t('内容')"  type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <goods-radio-select ref="goodsRadioSelect" @goodsSelect="indexGoodsModalSelect"/>
  </a-drawer>
</template>

<script>
import {getQuestion, addQuestion, updateQuestion} from '@/api/goods/question'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

import Editor from '@/components/Editor'
import GoodsRadioSelect from "@/views/goods/goods/select/GoodsRadioSelect.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    GoodsRadioSelect,
    CustomDictTag,
    LocaleFieldButton,
    Editor
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        goodsId: null,
        goodsName: null,
        type: null,
        content: null,
        parentId: null,
        status: 0,
        nickName: undefined,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        nickName: [{required: true, message: this.$t('昵称') + this.$t('不能为空'), trigger: 'blur'}],
        content: [{required: true, message: this.$t('内容') + this.$t('不能为空'), trigger: 'blur'}],
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        goodsId: null,
        goodsName: null,
        type: null,
        content: null,
        parentId: null,
        status: 0,
        nickName: undefined,
        localeFieldMap: {},
      }

    },
    indexGoodsModalSelect(records) {
      console.log('选择的商品:',records)
      this.form.goodsId = records[0].id
      this.form.goodsName = records[0].goodsName
    },
    openGoodsSelect() {
      this.$refs.goodsRadioSelect.openGoods(this.form.goodsId,null, null, [20,21]);
    },


    /** 新增按钮操作 */
    handleAdd(pid) {
      this.reset()
      if (pid) {
        this.form.parentId = pid
      }
      this.formType = 1;
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getQuestion({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateQuestion(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addQuestion(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
